import { service } from "../utils/request";

export function agentAdd(data) {
  // 添加活动
  return service({
    url: "bigwheel/agent.index/add",
    method: "post",
    data: data
  });
}

export function bigwheelList(data) {
  // 大转盘活动列表
  return service({
    url: "bigwheel/agent.index/index",
    method: "post",
    data: data
  });
}

export function bigwheelDel(data) {
  // 大转盘活动删除
  return service({
    url: "/bigwheel/agent.index/del",
    method: "post",
    data: data
  });
}

export function orderLIst(data) {
  // 大转盘d兑换列表
  return service({
    url: "/bigwheel/agent.bigwheelorder/index",
    method: "post",
    data: data
  });
}

export function shipments(data) {
  // 大转盘d兑换列表
  return service({
    url: "/bigwheel/agent.bigwheelorder/send",
    method: "post",
    data: data
  });
}
// 转盘修改
export function editBigList(data) {
  return service({
    url: "/bigwheel/agent.index/edit",
    method: "post",
    data: data
  });
}

// 大转盘详情
export function bigwheelorder(data) {
  return service({
    url: "/bigwheel/agent.index/detail",
    method: "post",
    data: data
  });
}

// 中奖列表
export function my_awardList(data) {
  return service({
    url: "/bigwheel/agent.User_Wheel_Products/index",
    method: "post",
    data: data
  });
}

// 中奖核销
export function my_awardAuth(data) {
  return service({
    url: "/bigwheel/agent.User_Wheel_Products/auth",
    method: "post",
    data: data
  });
}
